define('_models/Fan',[
	
],
function(
	
) {
	return Backbone.Model.extend({
		initialize: function(){

		},

		url : function() {
			var path =  "/_api/v0/fan/";
			path += (this.get('id')) ? this.get('id') : '';
			return path;
		}

	});
});

